import { formatTagsForAnalytics } from './formatAnalytics';

export type Restaurant = {
  id?: number | null;
  menuTitle?: string | null;
  region?: {
    id?: number | null;
    menuTitle?: string | null;
  } | null;
  suburb?: {
    id?: number | null;
    menuTitle?: string | null;
  } | null;
  cuisines?: {
    edges?:
      | {
          node?: {
            title?: string | null;
          } | null;
        }[]
      | null;
  } | null;
  rating?: number | null;
  approvedReviewsCount?: number | null;
};

export default function getRestaurantCartAnalysis(
  restaurant?: Pick<
    Restaurant,
    'cuisines' | 'id' | 'menuTitle' | 'region' | 'suburb' | 'rating' | 'approvedReviewsCount'
  > | null
) {
  if (!restaurant) {
    return [];
  }

  const edges = (restaurant.cuisines?.edges || []).filter(
    (edge): edge is { node: { title: string } } => !!edge.node?.title
  );

  return [
    {
      restaurant_id: restaurant.id,
      restaurant_name: restaurant.menuTitle,
      // restaurant_country_name: restaurant., // TODO: add country name
      restaurant_country_id: +(process.env.NEXT_PUBLIC_SITE_ID || 1),
      restaurant_region_id: restaurant.region?.id,
      restaurant_region_name: restaurant.region?.menuTitle,
      restaurant_suburb_id: restaurant.suburb?.id,
      restaurant_suburb_name: restaurant.suburb?.menuTitle,
      ...formatTagsForAnalytics({ edges }),
      restaurant_rating: restaurant.rating,
      restaurant_reviews_count: restaurant.approvedReviewsCount,
      // list_position: index + 1, // TODO: add list position
    },
  ];
}
